export const APP_ON_INITIALIZE_REQUESTED = 'APP_ON_INITIALIZE_REQUESTED';

export const APP_ON_TOGGLE_MENU_REQUESTED = 'APP_ON_TOGGLE_MENU_REQUESTED';
